import { Component, Input, OnInit } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { RequestParams } from '../../../../common/rest-api/models/request-params';
import { GRouteStopService } from '../../services/g-route-stops.service';
import { RouteStopModel } from '../../models/route-stop.model';
import { IRouteLogModel, RouteLogModel } from '../../models/route-log.model';
import { GRouteLogService } from '../../services/g-route-log.service';
import { LogType } from '../route-page/route.page';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { ModalController } from '@ionic/angular';
import { ToasterService } from '../../../../../app/common/services/toaster.service';
import { GRouteWorkOrdersService } from '../../services/route-work-order.service';
import { CancelOrderService } from '../../../../../app/features/cancel-order/services/cancel-order.service';
import { RouteDeliveryDetailsService } from '../../services/route-delivery-details.service';
import { GRouteService } from '../../services/g-route.service';
import { CustomerContactsService } from '../../services/customer-contacts.service';
import { CommonService } from '../../../../common/services/common.service';
@Component({
  selector: 'app-stop-info-menu-page',
  templateUrl: 'stop-info-menu.page.html',
  styleUrls: [
     './stop-info-menu.page.scss',
     '../../styles/g-route.styles.scss'
  ]
})
export class StopInfoMenuPage implements ViewWillEnter, OnInit {

    logType = LogType
    lastEvent: LogType = null;

    stopLogs: RouteLogModel[] = [];
    breadcrumbs=[];
    currentRoute: string;
    stopName: string;
    routeStop: RouteStopModel;
    loaded:Boolean=false;
     estRouteDate:Date;
    options = [
        {name: 'Check In', time: '--:--', check: true, type: this.logType.CHECK_IN, isLocked: false},
        {name: 'Contacts', path: 'contacts'},
//      {name: 'Upsell Opp.', path: 'upsell-opp'},
        {name: 'Non-Garments', path: 'non-garments'},
        {name: 'Customer AR Status', path: 'customer-AR-Status'},
        {name: 'Invoices', path: 'invoice'},
        {name: 'Check Out', time: '--:--', check: true, comment: true, type: this.logType.CHECK_OUT, isLocked: false}
    ];

    checkInOutOptions = [

    ]

    garmentOptions = [
        {name: 'Garment: New Deliveries', path: 'new-deliveries'},
        {name: 'Garment: Cancel Report', path: 'cancel-report'},
        {name: 'Garment: Pick Up', path: 'pick-up'},
        {name: 'Garment: Lookup', path: 'lookup'},
        {name: 'Garment: Repair', path: 'repair'},
        {name: 'Garment: Employee Lookup', path: 'employee-lookup'},
        {name: 'Garment: Add Wearer', path: 'add-wearer'}
    ]

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authService: GtrakAuthService,
        private stopService: GRouteStopService,
        private routeLogService: GRouteLogService,
        private modalController: ModalController,
        private toasterService: ToasterService,
        private routeWorkOrdersService: GRouteWorkOrdersService,
        private cancelOrderService: CancelOrderService,
        private routeDeliveryDetailsService: RouteDeliveryDetailsService,
        private gRouteService: GRouteService,
        private customerContactsService:CustomerContactsService,
        private commonService:CommonService
        
    ) { 
        this.currentRoute = null;
    }

    async ngOnInit(): Promise<void> {
        if(!this.authService.user.canViewDriverRoutes) {
            this.router.navigate([this.authService.user.homeLocation]);
        }

        this.currentRoute = this.router.url;
        this.stopName = this.route.snapshot.paramMap.get('id');

        this.breadcrumbs.push({ label: 'Home', url: '/route' });
        this.breadcrumbs.push({ label: 'Logsheet', url: '/route/logsheet' });
        const stop = await this.stopService.getStopByStopCode(this.stopName);
        this.routeStop = stop as any;
        localStorage.setItem('routeStopName', this.routeStop?.description);

        const gRoute = await this.gRouteService.get(
            this.authService.user.routeCode
        );
      
        const frequencyDate = gRoute.frequencyOffset(
            this.authService.user.routeDate
        );
         const forDateStr= this.commonService.getDateOnly(this.authService.user.routeDate);
        const promiseData = await Promise.all([
            this.routeWorkOrdersService.getNewDeliveryNumber(this.stopName, forDateStr),
            this.cancelOrderService.getNumberForStop(this.stopName),
            this.routeDeliveryDetailsService.GetNumberOfPickups(this.stopName, this.authService.user.routeCode, forDateStr, frequencyDate),
            this.customerContactsService.getCustomerArStatus(this.stopName)
       
        ]);

        const newDeliveries = promiseData[0];
        const cancelOrders = promiseData[1];
        const nonGarment = promiseData[2];
        const customerARStatus =promiseData[3];

        this.garmentOptions[0].name = this.garmentOptions[0].name + ` (${newDeliveries ?? 0})`;
        this.garmentOptions[1].name = this.garmentOptions[1].name + ` (${cancelOrders ?? 0})`;
        this.options[2].name = this.options[2].name + ` (${nonGarment ?? 0})`;
        this.options[3].name = this.options[3].name + ` (${ customerARStatus?? 0})`;
        this.loaded=true;
    }

    async ionViewWillEnter(): Promise<void> {
        this.loaded=false;
          const forDateStr= this.commonService.getDateOnly(new Date());
        this.stopLogs = await this.routeLogService.getStopLogs(this.authService.user.routeCode, this.stopName,forDateStr);
        if (this.stopLogs.length > 0) {
            this.stopLogs.forEach((log: RouteLogModel) => {
                const element = this.options.find((option) => option.type === log.logType);
                element.time = this.getTimeFromDate(log.logDate);
                element.isLocked = true;
            });
        }
         this.loaded=true;
    }

    navigate(item: any): void {
        if(item.path){
            this.router.navigate([this.currentRoute + '/' + item.path]);
        }
    }

    async setTime(section: any): Promise<void> {
        //if section type is check out redirect to checkout page
        if(section.type === this.logType.CHECK_OUT) {
            this.router.navigate([this.currentRoute + '/check-out']);
            return;
        }
        //Add a pop up to confirm 
        if (!section.isLocked) {
            const modal = this.modalController.create({
                component: ConfirmationPopupComponent,
                cssClass: "min-width-modal",
                showBackdrop: true,
                componentProps: {
                    stop: this.stopName,
                    event: (section.type === this.logType.CHECK_IN) ? 'check in' : 'check out'
                },
                backdropDismiss: true,
                keyboardClose: true,
                swipeToClose: true,
            });
             this.loaded=false;
            (await modal).present();
            const {data} = await (await modal).onDidDismiss();
            if (data) {
                var estdate=new Date(new Date());
                const log: IRouteLogModel = {
                    logType: section.type,
                    routeCode: this.authService.user.routeCode,
                    stopCode: this.stopName,
                    odometer: 0,
                    time: estdate,
                    driverCode: (this.authService.user.id as string)
                };
        
                const response = await this.routeLogService.createRouteLog(log);
        
                this.lastEvent = section.type;
                this.options.find(x => x.name === section.name).time = this.getCurrentTime();
                
                section.isLocked = true;
                 this.loaded=true;
            }else{
                this.loaded=true;
            }
        } else {
            this.toasterService.presentToast('warning', '', `You are already ${(section.type === this.logType.CHECK_IN) ? 'checked in' : 'checked out'} of this stop.`, 1500);
        }    
    }

    getCurrentTime(): string {
        var displayHours: string;
        var displayMinutes: string;
        var ampm: string;
        const estdate = this.commonService.getEasternCurrentDate();
        var hours = estdate.getHours();
        var minutes =estdate.getMinutes();
        if (hours >= 12) {
            ampm = 'PM';
        } else {
            ampm = 'AM';
        }
    
        hours = hours % 12; 
        if (hours === 0) {
            hours = 12;
        }
    
        if (hours < 10) {
            displayHours = '0' + hours;
        } else {
            displayHours = String(hours);
        }
    
        if (minutes < 10) {
            displayMinutes = '0' + minutes;
        } else {
            displayMinutes = String(minutes);
        }
    
        return displayHours + ':' + displayMinutes + ' ' + ampm;
    }

    getTimeFromDate(date: Date): string {
        if (typeof date === 'string') {
          var date=new Date(date);
        }
        if (!(date instanceof Date) || isNaN(date.getTime())) {
            throw new Error('Invalid date');
        }
    
        var displayHours: string;
        var displayMinutes: string;
        var ampm: string;
        var hours = new Date(date.toString()).getHours();
        var minutes = new Date(date.toString()).getMinutes();
        if (hours >= 12) {
            ampm = 'PM';
        } else {
            ampm = 'AM';
        }
    
        hours = hours % 12; 
        if (hours === 0) {
            hours = 12;
        }
    
        if (hours < 10) {
            displayHours = '0' + hours;
        } else {
            displayHours = String(hours);
        }
    
        if (minutes < 10) {
            displayMinutes = '0' + minutes;
        } else {
            displayMinutes = String(minutes);
        }
    
        return displayHours + ':' + displayMinutes + ' ' + ampm;
    }

}